import * as React from "react";
import { Fab, styled } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function CreateButton({ onClick }) {
  return (
    <StyledFab color="primary" aria-label="add" onClick={onClick}>
      <AddIcon />
    </StyledFab>
  );
}

const StyledFab = styled(Fab)`
  margin: 10px 20px;
`;
